module.exports = __webpack_public_path__ + "static/media/hotel-main.a2c0b6d5.jpg";